export default __webpack_public_path__ + "static/media/eco-image-01.0d7b7c85.png";